import {Injectable} from '@angular/core';
import {BreadcrumbDto, CompoApiService, LazyCatalog} from 'compob2b-libs';
import {Observable} from 'rxjs';
import {map, share} from 'rxjs/operators';
import {FILES_TYPES_THUMBNAILS} from './files/files-types-thumbnails.config';

@Injectable({
  providedIn: 'root'
})
export class DamService {

  constructor(protected readonly compoApiService: CompoApiService) {
  }

  public getLazyCatalogTree(): Observable<LazyCatalog[]> {
    return this.compoApiService.get<LazyCatalog[]>('/catalog/lazy')
      .pipe(
        share(),
        map(response => response.data),
      );
  }

  getCatalogBreadCrumbs(id: number): Observable<BreadcrumbDto[]> {
    const uri = `/dam-menu/catalog-parent-chain/${id}`;
    return this.compoApiService.get<BreadcrumbDto[]>(uri)
      .pipe(
        map(response => response.data),
      );
  }

  public showThumbnail(mimeType) {
    return FILES_TYPES_THUMBNAILS.includes(mimeType);
  }

  public getExtension(item): string {
    return item.header.split(/[. ]+/).pop();
  }
}
